import { createFileRoute } from "@tanstack/react-router";
import Reviews from "@/pages/Reviews";
import { reviewsHead } from "@/lib/route-seo";

export const Route = createFileRoute("/reviews")({
  head: () => reviewsHead(),
  component: Reviews,
});
